import { gql } from "@apollo/client";

export const DELETE_MEETING = gql`
  mutation DeleteMeeting($meeting_id: Int!) {
    delete_meeting(meeting_id: $meeting_id) {
      status
      status_code
      message
    }
  }
`;

export const UPDATE_TASKS_MUTATION = gql`
  mutation UpdateTasks($task_id: Int!, $task_status: String!, $updated_by: String!) {
    update_tasks(task_id: $task_id, task_status: $task_status, updated_by: $updated_by) {
      status
      message
      status_code
      data {
        id
        task_status
        created_by
        created_on
        updated_by
        updated_on
      }
    }
  }
`;

export const CREATE_TASK_MUTATION = gql`
  mutation CreateTasks(
    $employee_id: String!
    $task_date: DateTime!
    $task_name: String!
    $task_type: String!
    $task_status: String!
    $client_location_id: Int!
    $created_by: String!
  ) {
    create_tasks(
      tasks_input: {
        employee_id: $employee_id
        task_date: $task_date
        task_name: $task_name
        task_status: $task_status
        task_type: $task_type
        client_location_id: $client_location_id
        created_by: $created_by
      }
    ) {
      status
      message
      status_code
      data {
        id
        employee_id
        task_date
        task_name
        task_status
        notes
        client_location_id
        start_date
        end_date
        reason
        task_type
        created_by
        created_on
        updated_by
        updated_on
      }
    }
  }
`;

export const CREATE_CAREGIVER_REMINDERS = gql`
  mutation Create_caregiver_reminders($reminder_input: CaregiverRemindersInput!) {
    create_caregiver_reminders(reminder_input: $reminder_input) {
      status
      status_code
      message
      data {
        id
        reminders
        caregiver_uuid
        task_status
        reason
        status
        is_visible_in_app
        remind_date
        task_status_updated_by
        created_by
        updated_by
        created_on
        updated_on
      }
    }
  }
`;

//wizkind mutation
export const WIZKIND_LOGIN_WITH_OTP = gql`
  mutation Wizkind_login_with_otp($email: String!, $otp: String!) {
      wizkind_login_with_otp(email: $email, otp: $otp) {
          status
          message
          status_code
          employees {
              employee_id
              sex
              dob
              date_of_joining
              designation
              address
              state_name
              city_id
              contact_no
              email_id
              emergency_contact_no
              emergency_contact_person
              salary
              image_url
              created_by
              created_on
              updated_by
              updated_on
              status
              password
              identifier
              device_registration_id
              address_line
              zip
              credentials
              last_login
              verapal_status
              time_zone
              independent_contractor
              password_salt
              uuid
              country
              inactive_reason
              device_type
              agency_location_id
              first_name
              last_name
              access_type
              external_employees_uuid
              is_imported_from_external
              sync_type
              ssn
              job_target_user_id
              paylocity_tracking_id
              paylocity_employee_id
              payee_tax_id_type
              is_exportkyck
              kyck_payee_id
              payment_mode
              employee_type
              inactive_secondary_reason
              is_request_accepted
              report_time
              is_request_rejected
              clock_out_hour
              clock_out_minute
              is_in_standing_meeting
              agencies {
                  id
                  first_name
                  dob
                  gender
                  contact_no
                  email_id
                  address
                  state
                  logo_image
                  status
                  middle_name
                  last_name
                  address_line
                  zip
                  last_login
                  company_name
                  time_zone
                  facebook_link
                  twitter_link
                  website
                  uuid
                  country
                  db_time_zone
                  invoice_unique_id
                  city
              }
              employee_roles {
                id
                role_name
                createdon
                updatedon
              }
              skills {
                id
                proficiency_level
                years_of_experience
                certified
                assigned_date
                skill_name
                skill_id
              }
              token
              app_user_id
          }
      }
  }
`

export const DUMMY_MUTATION = gql`
  mutation Dummy_mutation($name: String!) {
    dummy_mutation(name: $name) {
        success
        message
    }
  }
`

export const CREATE_GOAL = gql`
  mutation Create_goal($goal_data: GoalInput!) {
    create_goal(
        goal_data: $goal_data
    ) {
        status
        message
        status_code
                   goal {
             id
}
    }
  }
`

export const CHANGE_TASK_STATUS = gql`
mutation Change_task_status(
  $created_by_id: Int!
  $input: TaskChangeStatusInput!
) {
    change_task_status(
        created_by_id: $created_by_id
        input: $input
    ) {
        status
        message
        status_code
    }
  }
`

export const CREATE_CLOCK_IN_OUT = gql`
  mutation Create_clock_in_out($input: CreateClockInOutInput!) {
    create_clock_in_out(
        input: $input
    ) {
        clock_in {
            id
            employees_id
            check_in_time
            check_out_time
            is_check_in
            in_latitude
            in_longitude
            out_latitude
            out_longitude
            agencies_id
            checked_by
            status
            is_payroll
            check_in_distance
            check_out_distance
            check_in_address
            check_out_address
            clock_out_comment
            minutes
            is_clock_out_notification_send
            hours
            is_auto_clock_out
            is_auto_clock_out_task_update_enable
            created_by
            created_on
            updated_by
            updated_on
        }
        errors {
            field
            messages
        }
        clientMutationId
    }
  }
`

export const CREATE_PROJECT = gql`
  mutation Create_project($input: ProjectInputType!) {
    create_project(input: $input) {
        status
        message
        status_code
        project {
            id
            name
            status_change_date
            created_on
            updated_on
            created_by
            status_id
            updated_by
            is_default
            tagline
            niche
            ideal_customer_profile
            unique_about_it
            image_url
            created_by_name
        }
    }
  }
`

export const UPDATE_DEPENDENCY = gql`
  mutation Update_dependency($id: Int!, $is_resolved: Boolean!) {
    update_dependency(id: $id, is_resolved: $is_resolved) {
        status
        message
        status_code
        dependency {
            id
            task_id
            dependency_reason
            is_resolved
            created_by
            created_date
            dependent_person_id
            blocking_person_id
            dependent_person_name
            blocking_person_name
            task_title
        }
    }
  }
`

export const CREATE_DEPENDENCY = gql`
  mutation Create_dependency($input: BlockersDependencyInputType!) {
    create_dependency(
        input: $input
    ) {
        status
        message
        status_code
    }
  }
`

export const CREATE_DEFECT = gql`
  mutation Create_defect($input: BlockersDefectInputType!) {
    create_defect(
        input: $input
    ) {
        status
        message
        status_code
    }
  }
`

export const UPDATE_DEFECT = gql`
  mutation Update_defect($id: ID!, $input: BlockersDefectInputType!) {
    update_defect(id: $id, input: $input) {
        status
        message
        status_code
    }
  }
`

export const RESOLVE_DEFECT = gql`
  mutation Resolve_defect($id: ID!, $is_resolved: Boolean!, $resolution_note: String, $file_url: String,$resolved_by:Int,$is_approved:Boolean) {
    resolve_defect(id: $id, is_resolved: $is_resolved, resolution_note: $resolution_note, file_url: $file_url,resolved_by:$resolved_by,is_approved:$is_approved) {
        status
        message
        status_code
    }
  }
`

export const DELETE_ATTACHMENT = gql`
  mutation Delete_defect_attachment($id: ID!) {
    delete_defect_attachment(id: $id) {
        status
        message
        status_code
    }
  }
`

export const CREATE_EMPLOYEE = gql`
  mutation Create_employee($input: CreateEmployeeInput!) {
    create_employee(
        input: $input
    ) {
        status
        message
        status_code
    }
  }
`

export const CREATE_BREAK = gql`
  mutation Create_breaks($input: ClockInOutClockInBreaksInputType!) {
    create_breaks(input: $input) {
        status
        message
        status_code
        clock_in_break {
            id
            start_time
            end_time
            in_latitude
            in_longitude
            out_latitude
            out_longitude
            agencies_id
            status
            is_break_in
            break_start_address
            break_end_address
            created_by
            created_on
            updated_by
            updated_on
            clock_in_id
        }
    }
  }
`

export const LEAVE_APPLY = gql`
  mutation Leave_apply($input: LeaveApplyBulkLeaveInput!) {
    leave_apply(
        input: $input
    ) {
        status
        message
        status_code
    }
  }
`

export const UPDATE_LEAVE_STATUS = gql`
  mutation Update_leave_status($ids: [ID]!, $leave_status: String!) {
    update_leave_status(ids: $ids, leave_status: $leave_status) {
        status
        message
        status_code
    }
  }
`

export const CREATE_MEETING = gql`
  mutation Create_meeting($input: MeetingsMeetingInputType!) {
    create_meeting(input: $input) {
        status
        message
        status_code
        meeting_id
    }
  }
`

export const DELETE_BULK_MEETINGS = gql`
  mutation Delete_bulk_meetings($deleted_by: Int!, $meeting_ids: [Int]!) {
    delete_bulk_meetings(deleted_by: $deleted_by, meeting_ids: $meeting_ids) {
        status
        message
        status_code
    }
  }
`

export const MEETING_ACTIONS = gql`
  mutation Meeting_actions(
      $meeting_id: Int!
      $agendas: [MeetingsMeetingAgendaInputType]
      $external_members: [MeetingsExternalMeetingMembersInputType]
      $members: [MeetingsMeetingMembersInputType]
      $outcome: String
      $is_email_send: Boolean
    ) {
    meeting_actions(
      meeting_id: $meeting_id
      agendas: $agendas
      external_members: $external_members
      members: $members
      outcome: $outcome
      is_email_send: $is_email_send
    ) {
        status
        message
        status_code
    }
  }
`

export const CREATE_UPDATE_TODO = gql`
  mutation Create_update_todo(
      $created_by: Int!
      $input: ToDoPmTodoInputType!
    ) {
    create_update_todo(
      created_by: $created_by
      input: $input 
    ) {
        status
        message
        status_code
          todos {
           id  
        }
    }
  }
`

export const TODO_ACTIONS = gql`
  mutation Todo_actions($id: Int!, $is_completed: Boolean!, $completed_date: DateTime) {
    todo_actions(id: $id, is_completed: $is_completed, completed_date: $completed_date) {
        status
        message
        status_code
    }
  }
`

export const CUSTOMER_EMAIL_ACTIONS = gql`
  mutation Customer_email_actions(
      $id: ID!
      $is_archived: Boolean
      $is_follow_up_required: Boolean
      $is_replied: Boolean
    ) {
    customer_email_actions(
      id: $id
      is_archived: $is_archived
      is_follow_up_required: $is_follow_up_required
      is_replied: $is_replied
    ) {
        status
        message
        status_code
    }
  }
`

export const TICKET_ACTIONS = gql`
  mutation Ticket_actions($id: ID!, $priority: String , $status: String ) {
    ticket_actions(id: $id, priority: $priority, status: $status) {
        status
        message
        status_code
    }
  }
`

export const CREATE_SKILLS = gql`
  mutation Create_skills($skills_input: [EmployeeSkillsSkillsInput]!) {
    create_skills(skills_input: $skills_input) {
        status
        message
        status_code
    }
  }
`

export const DELETE_SKILLS = gql`
  mutation Delete_skills($skill_ids: [Int]!) {
    delete_skills(skill_ids: $skill_ids) {
        status
        message
        status_code
    }
  }
`

export const UPDATE_EMPLOYEE = gql`
  mutation Update_employee($employee_id: Int!, $input: UpdateEmployeeInput!) {
    update_employee(employee_id: $employee_id, input: $input) {
        status
        message
        status_code
    }
  }
`

export const CREATE_IDEA_GOAL = gql`
  mutation Create_idea_goal(
      $input: IdeaBoxIdeaGoalInput!
    ) {
    create_idea_goal(
        input: $input
    ) {
        status_code
        message
        status
        idea_goal {
            id
            title
            project_id
            goals_static_id
            expected_closing_date
            priority
            user_selected
            created_at
            updated_at
            impact_level_name
            outcome_name
            project_name
            goals_static_name
        }
    }
  }
`

export const UPDATE_IDEA_GOAL = gql`
  mutation Update_idea_goal($input: IdeaBoxIdeaGoalUpdateInput!) {
    update_idea_goal(input: $input) {
        status
        message
        status_code
    }
  }
`

export const CREATE_IDEA_FOLLOWERS = gql`
  mutation Create_idea_followers($employee_ids: [Int]!, $idea_goal_id: Int!) {
    create_idea_followers(employee_ids: $employee_ids, idea_goal_id: $idea_goal_id) {
        status
        message
        status_code
    }
  }
`

export const DELETE_IDEA_FOLLOWER = gql`
  mutation Delete_idea_followers($employee_ids: [Int]!, $idea_goal_id: Int!) {
    delete_idea_followers(employee_ids: $employee_ids, idea_goal_id: $idea_goal_id) {
        status
        message
        status_code
    }
  }
`

export const DELETE_CLOCK_IN_OUT = gql`
  mutation Delete_clock_in_out(
    $clock_in_id: Int
    $is_add_leave: Boolean
    $leave_apply_input: LeaveApplyBulkLeaveInput
  ) {
    delete_clock_in_out(
      clock_in_id: $clock_in_id
      is_add_leave: $is_add_leave
      leave_apply_input: $leave_apply_input
    ) {
        status
        message
        status_code
    }
  }
`

export const ADMIN_CREATE_CLOCK_IN = gql`
  mutation Admin_create_clock_in($input: AdminClockInInputType!) {
    admin_create_clock_in(input: $input) {
        status
        message
        status_code
    }
  }
`

export const CREATE_EMPLOYEE_PEER = gql`
  mutation Create_employee_peer_points(
      $input: PeerPointsEmployeesPeerPointsInput!
    ) {
    create_employee_peer_points(
      input: $input
    ) {
        status
        message
        status_code
        remaining_points
        peer_point {
            id
            point
            reason
            given_by
            created_by
            created_on
        }
    }
  }
`

export const CREATE_OR_UPDATE_AGENCY_PEER_POINT_PER_MONTH = gql`
  mutation Create_or_update_agency_peer_point_per_month($input: PeerPointsAgencyPeerPointPerMonthInput!) {
    create_or_update_agency_peer_point_per_month(input: $input) {
        status
        message
        status_code
        agency_peer_point {
            id
            peer_point_per_month
            created_on
            created_by
            updated_on
            updated_by
            agency_id
        }
    }
  }
`

export const DELETE_IDEA_GOAL = gql`
  mutation Delete_idea_goal($id: Int!) {
    delete_idea_goal(id: $id) {
        status
        message
        status_code
    }
  }
`

export const CREATE_MIGRATION_AGENCY = gql`
  mutation Create_migration_agency($assigned_members: [AssignedTeamMemberInputType], $input: MigrationAgencyInputType!) {
    create_migration_agency(assigned_members: $assigned_members, input: $input) {
        status
        message
        status_code
    }
  }
`

export const SYNC_AGENCY_FIELD_STATUS = gql`
  mutation Sync_agency_field_statuses($agency_id: Int!) {
    sync_agency_field_statuses(agency_id: $agency_id) {
        status
        message
        status_code
        created_count
    }
  }
`

export const SYNC_ENTITIES = gql`
  mutation Sync_entities($agency_id: Int!, $entity_type: SyncEntityType!) {
    sync_entities(agency_id: $agency_id, entity_type: $entity_type) {
        status
        message
        status_code
        created_count
        updated_count
    }
  }
`

export const SYNC_ENTITIES_NEW = gql`
  mutation Sync_entities_from_db_then_api($agency_id: Int!, $entity_type: SyncEntityType!, $agency_location_id: Int!, $agency_obj_id: Int!, $agency_type: String!) {
    sync_entities_from_db_then_api(agency_id: $agency_id, entity_type: $entity_type, agency_location_id: $agency_location_id, agency_obj_id: $agency_obj_id, agency_type: $agency_type) {
        status
        message
        status_code
    }
  }
`

export const SYNC_ENTITIES_FIELD_STATUS = gql`
  mutation Sync_entity_field_statuses($agency_id: Int!, $agency_type: String!) {
    sync_entity_field_statuses(agency_id: $agency_id, agency_type: $agency_type) {
        status
        message
        status_code
        created_count
    }
  }
`

export const BULK_UPSERT_AGENCY_FIELD_STATUS = gql`
  mutation Bulk_upsert_agency_field_status($agency_id: Int!, $field_statuses: [BulkAgencyFieldStatusInputType]!) {
    bulk_upsert_agency_field_status(agency_id: $agency_id, field_statuses: $field_statuses) {
        status
        message
        status_code
        updated_count
    }
  }
`

export const BULK_ASSIGN_MEMBERS_TO_ENTITIES = gql`
  mutation Bulk_assign_members_to_entities($assignments: [BulkAssignMemberInputType]!) {
    bulk_assign_members_to_entities(assignments: $assignments) {
        status
        message
        status_code
        assigned_count
    }
  }
`

export const BULK_REMOVE_MEMBERS_FROM_ENTITIES = gql`
  mutation Bulk_unassign_members_from_entities($entity_ids: [Int]!) {
    bulk_unassign_members_from_entities(entity_ids: $entity_ids) {
        status
        message
        status_code
        unassigned_count
    }
  }
`

export const BULK_UPSERT_ENTITY_FIELD_STATUS = gql`
  mutation Bulk_upsert_entity_field_status(
        $agency_id: Int!
        $entity_id: Int!
        $entity_type: String!
        $field_statuses: [BulkEntityFieldStatusInputType]!
    ) {
    bulk_upsert_entity_field_status(
        agency_id: $agency_id
        entity_id: $entity_id
        entity_type: $entity_type
        field_statuses: $field_statuses
    ) {
        status
        message
        status_code
        updated_count
    }
  }
`

export const BULK_UPDATE_ENTITY_STATUS = gql`
  mutation Bulk_update_entity_status($entity_ids: [Int]!, $progress_status: EntityProgressStatus!) {
    bulk_update_entity_status(entity_ids: $entity_ids, progress_status: $progress_status) {
        status
        message
        status_code
        updated_count
    }
  }
`

export const CREATE_SCREEN = gql`
  mutation Create_screen($input: ScreenInputType!) {
    create_screen(input: $input) {
      status
      message
      status_code
      screen {
        id
        name
        release_date
        frontend_developer_name
        backend_developer_name
        qa_name
      }
    }
  }
`

export const CREATE_BUG = gql`
  mutation Create_bug($input: BugInputType!) {
    create_bug(input: $input) {
        status
        status_code
        bug {
            id
            bug_status
            bug_assigned_name
        }
    }
  }
`

export const CREATE_ENHANCEMENT = gql`
  mutation Create_enhancement($input: EnhancementInputType!) {
    create_enhancement(input: $input) {
        status
        status_code
        enhancement {
            id
            enhancement_status
            enhancement_assigned_name
        }
    }
  }
`

export const ADD_BUG_HISTORY = gql`
  mutation Add_bug_history($input: BugHistoryInputType!) {
    add_bug_history(input: $input) {
        status
        status_code
        history {
            id
            worked_by_name
            changes_made
            worked_on
        }
    }
  }
`

export const ADD_ENHANCEMENT_HISTORY = gql`
  mutation Add_enhancement_history($input: EnhancementHistoryInputType!) {
    add_enhancement_history(input: $input) {
        status
        status_code
         history {
            id
            worked_by
            changes_made
            worked_on
            created_by
            created_on
            worked_by_name
            created_by_name
        }
    }
  }
`

export const DELETE_BUG = gql`
  mutation Delete_bug($bug_id: Int!) {
    delete_bug(bug_id: $bug_id) {
        status
        status_code
        message
    }
  }
`

export const DELETE_BUG_HISTORY = gql`
  mutation Delete_bug_history($history_id: Int!) {
    delete_bug_history(history_id: $history_id) {
        status
        status_code
        message
    }
  }
`

export const UPDATE_BUG_WORKFLOW = gql`
  mutation Update_bug_workflow(
    $bug_id: Int!
    $bug_status: String
    $bug_assigned: Int
    $remarks: String
    $updated_by: Int!
  ) {
    update_bug_workflow(
      bug_id: $bug_id
      bug_status: $bug_status
      bug_assigned: $bug_assigned
      remarks: $remarks
      updated_by: $updated_by
    ) {
        status
        status_code
        message
        bug {
            id
            bug_status
            bug_assigned
            bug_assigned_name
            remarks
            updated_by
        }
    }
  }
`
export const PATCH_DEFECT = gql`
  mutation Patch_defect($id: ID!,$input:PatchDefectInputType!) {
    patch_defect(id: $id,input:$input) {
        status
        status_code
        message
        defect {
            id
            reference_id
            reference_name
            title
            description
            severity
            is_resolved
            created_by
            created_on
            is_issue
            is_confirmed
            confirmed_by
            steps_to_reproduce
            expected_behavior
            actual_behavior
            screen_name
            reporter_name
            agency_name
            action_type
            is_goal_exist
            goal_id
            
        }
    }
  }`

  export const UPSERT_POD = gql`
  mutation Upsert_pod($input: UpsertPodInput!) {
    upsert_pod(input: $input) {
      status
      message
      status_code
      pod_id
    }
  }
`;

  export const DELETE_POD = gql`
  mutation Delete_pod($pod_id: Int!) {
    delete_pod(pod_id: $pod_id) {
      status
      message
      status_code
    }
  }
`;

// BuildPack template system mutations
export const CREATE_GOAL_FROM_TEMPLATE = gql`
  mutation CreateGoalFromTemplate(
    $template_id: String!
    $project_id: Int!
    $created_by: Int!
    $start_date: DateTime!
    $end_date: DateTime!
    $description: String
    $goal_members: [Int]
    $goal_skill_ids: [Int]
    $task_assignees: [TaskAssigneeInput]
  ) {
    create_goal_from_template(
      template_id: $template_id
      project_id: $project_id
      created_by: $created_by
      start_date: $start_date
      end_date: $end_date
      description: $description
      goal_members: $goal_members
      goal_skill_ids: $goal_skill_ids
      task_assignees: $task_assignees
    ) {
      status
      message
      goal_id
      wizkind_goal_id
    }
  }
`;

export const TICK_CHECKLIST_ITEM = gql`
  mutation TickChecklistItem($item_id: String!, $ticked_by: String!) {
    tick_checklist_item(input: { item_id: $item_id, ticked_by: $ticked_by }) {
      status
      message
    }
  }
`;

export const CREATE_SCREEN_API = gql`
  mutation Create_screen_api($input: ScreenApiInputType!) {
    create_screen_api(input: $input) {
      status
      message
      status_code
      screen_apis {
        id
        api_name
        api_endpoint
        description
      }
    }
  }
`;

export const DELETE_SCREEN_API = gql`
  mutation Delete_screen_api($screen_api_id: Int!) {
    delete_screen_api(screen_api_id: $screen_api_id) {
      status
      message
      status_code
    }
  }
`;

export const DELETE_SCREEN = gql`
  mutation Delete_screen($screen_id: Int!,$deleted_by:Int!) {
    delete_screen(screen_id: $screen_id,deleted_by:$deleted_by) {
      status
      message
      status_code
    }
  }
`;

export const REASSIGN_DEFECT_GOAL = gql`
  mutation Reassign_defect_goal(
    $defect_id: Int!,
    $goal_data: GoalInput!,
    $new_action_type: String,
    $new_pod_id: Int,
    $created_by_name:String
  ){
    reassign_defect_goal(
      defect_id: $defect_id
      goal_data: $goal_data
      new_action_type: $new_action_type
      new_pod_id: $new_pod_id
      created_by_name:$created_by_name
    ){
      status
      message
      status_code
    }
  }
`;

export const CREATE_POD_GOAL = gql`
  mutation Create_pod_goal(
    $pod_id: Int!
    $title: String!
    $start_date: DateTime
    $task_assignees: [PodGoalTaskAssigneeInput]
    $template_tag: String
    $action_type: String
    $defect_id: Int
    $description: String
    $task_tag:String
    $project_id: Int!
  ) {
    create_pod_goal(
      pod_id: $pod_id
      title: $title
      action_type: $action_type
      defect_id: $defect_id
      description: $description
      start_date: $start_date
      task_assignees: $task_assignees
      template_tag: $template_tag
      task_tag:$task_tag
      project_id:$project_id
    ) {
      status
      message
      status_code
      goal {
        id
        title
      }
    }
  }
`;

export const UPDATE_POD_GOAL = gql`
mutation Update_pod_goal(
    $goal_id: Int!
    $description: String
    $end_date: DateTime
    $start_date: DateTime
    $title: String!
    $what_building:String
    $task_updates: [PodGoalTaskUpdateInput]
        $duplicate_tasks: [PodGoalTaskDuplicateInput]
        $skill_ids:[Int]
  ) {
    update_pod_goal(
      goal_id: $goal_id
      description: $description
      end_date: $end_date
      start_date: $start_date
      title: $title
      task_updates: $task_updates
      duplicate_tasks: $duplicate_tasks
      skill_ids:$skill_ids
      what_building:$what_building
    ) {
      status
      message
      status_code
    goal {
            id
            title
            description
            start_date
            end_date
            status
            created_by
            created_on
            updated_by
            updated_on
            pod_id
        }
    }
  }
`

export const COMPLETE_POD_GOAL_TASK = gql`
  mutation Complete_pod_goal_task(
    $task_id: Int!
    $end_datetime: DateTime
    $start_datetime: DateTime
    $ticked_checklist_ids: [Int]
    $assigned_to:Int
    $skill_ids:[Int]
     $task_note: String 
  ) {
    complete_pod_goal_task(
      task_id: $task_id
      end_datetime: $end_datetime
      start_datetime: $start_datetime
      ticked_checklist_ids: $ticked_checklist_ids
      assigned_to:$assigned_to
      skill_ids:$skill_ids
       task_note: $task_note 
    ) {
      status
      message
      status_code
    }
  }
`;


export const REASSIGN_POD_GOAL = gql`
  mutation Reassign_pod_goal(
    $goal_id: Int!
    $new_pod_id:Int!
    $action_type:String
      $task_tag: String
  ) {
    reassign_pod_goal(
      goal_id: $goal_id
      new_pod_id:$new_pod_id
      action_type:$action_type
          task_tag: $task_tag
    ) {
      status
      message
      status_code
    }
  }
`;


export const SAVE_RESOURCE_WORKING_DATES = gql`
  mutation Save_resource_working_dates(
    $employees: [ResourceWorkingDateEmployeeInput]!
    $startDate: DateTime!
    $endDate: DateTime!
    $notes: String
    $createdBy: String
    $is_overnight:Boolean
  ) {
    save_resource_working_dates(
      employees: $employees
      start_date: $startDate
      end_date: $endDate
      notes: $notes
      created_by: $createdBy
      is_overnight:$is_overnight
    ) {
        status
        message
        status_code
        created_count
        updated_count
        records {
            id
            employee_id
            start_date
            end_date
            notes
            created_by
            created_on
            updated_by
            updated_on
            employee_name
        }
    }
  }
`;

export const UPDATE_RESOURCE_WORKING_DATE = gql`
  mutation Update_resource_working_date(
    $id: Int!
    $employeeId: Int
    $startDate: DateTime
    $endDate: DateTime
    $notes: String
  ) {
    update_resource_working_date(
      id: $id
      employee_id: $employeeId
      start_date: $startDate
      end_date: $endDate
      notes: $notes
    ) {
        status
        message
        status_code
        record {
            id
            employee_id
            start_date
            end_date
            notes
            created_by
            created_on
            updated_by
            updated_on
            employee_name
        }
    }
  }
`;

export const DELETE_RESOURCE_WORKING_DATES = gql`
   mutation Delete_resource_working_dates($ids: [Int]!) {
    delete_resource_working_dates(ids: $ids) {
        status
        message
        status_code
        deleted_ids
    }
  }
`;

export const SET_EXTRA_DAY = gql`
    mutation Set_extra_day($clock_in_id: Int!) {
        set_extra_day(clock_in_id: $clock_in_id) {
            status
            message
            status_code
            clock_in {
                id
                employees_id
                check_in_time
                check_out_time
                is_check_in
                is_extra_day
                in_latitude
                in_longitude
                out_latitude
                out_longitude
                agencies_id
                checked_by
                status
                is_payroll
                check_in_distance
                check_out_distance
                check_in_address
                check_out_address
                clock_out_comment
                minutes
                is_clock_out_notification_send
                hours
                is_auto_clock_out
                is_auto_clock_out_task_update_enable
                created_by
                created_on
                updated_by
                updated_on
                week_day
            }
        }
    }
`;

export const SET_NIGHT_SHIFT = gql`
  mutation Set_night_shift($clock_in_id: Int!) {
    set_night_shift(clock_in_id: $clock_in_id) {
      status
      message
      status_code
      clock_in {
        id
        employees_id
        check_in_time
        check_out_time
        is_check_in
        is_extra_day
        is_night_shift
        in_latitude
        in_longitude
        out_latitude
        out_longitude
        agencies_id
        checked_by
        status
        is_payroll
        check_in_distance
        check_out_distance
        check_in_address
        check_out_address
        clock_out_comment
        minutes
        is_clock_out_notification_send
        hours
        is_auto_clock_out
        is_auto_clock_out_task_update_enable
        created_by
        created_on
        updated_by
        updated_on
        week_day
      }
    }
  }
`;

export const CREATE_POD_GOAL_CUSTOM = gql`
  mutation Create_pod_goal_custom($input: CreatePodGoalCustomInput!) {
    create_pod_goal_custom(input: $input) {
      status
      message
      status_code
      goal_id
    }
  }
`;


